import { render, staticRenderFns } from "./provision.vue?vue&type=template&id=962ab296&"
import script from "./provision.vue?vue&type=script&lang=ts&"
export * from "./provision.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports